$(document).ready(function(){
  	if  ($('#SingleOptionSelector-1').is(":visible")) {
      var test = $('#SingleOptionSelector-1 option:selected').attr("op-select");
    }else{
    	var test = $('.single-option-selector option:selected').attr("op-select");
    }
    
    if(typeof test == 'undefined'){
   	 $('.variant_desc').show();
    }else{
      $('#parent_desc').show();
      $('.variant_desc').hide();
      	$('.'+test+'').show();
    }
    $('.single-option-selector').change(function(){
    	if  ($('#SingleOptionSelector-1').is(":visible")) {
          var test = $('#SingleOptionSelector-1 option:selected').attr("op-select");
        }else{
            var test = $('.single-option-selector option:selected').attr("op-select");
        }
       
        $('#parent_desc').show();
      	$('.variant_desc').hide();
      	$('.'+test+'').show();
    });

  $('.about').show();
  $('.customDC').click(function(){
  	var myid = this.id;
    
    //for the contents
    $('.customD').each(function(){
    	$(this).hide(); 
    });
    //for the label
    $('.customDC').each(function(){
      $(this).removeClass('selected');
    });
    
    $(this).addClass('selected');
    $('.'+myid).show();
    
    /**
    if(myid=='about'){
    	if  ($('#SingleOptionSelector-1').is(":visible")) {
          var test = $('#SingleOptionSelector-1 option:selected').attr("op-select");
        }else{
            var test = $('.single-option-selector option:selected').attr("op-select");
        }
       
      	$('.variant_desc').hide();
      	$('.'+test+'').show();
    }
    **/
    
  });
});